import {
  Button,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  notification,
  Radio,
  Select,
  TreeSelect,
  Upload,
  UploadFile,
  UploadProps,
} from 'antd';
import React, { useEffect, useState } from 'react';
import {
  ChildrenTagScreenResponseInterface,
  clearVerdictAction,
  createVerdictAction,
  VerdictStateInterface,
  deleteVerdictAction,
  DisplayDateFormat,
  FileFormatEnum,
  FileService,
  FilterNameEnumHR,
  getScreenTagsByTypeAction,
  getSingleVerdictAction,
  i18n,
  NavigationService,
  SelectTypeEnum,
  store,
  StoreStateInterface,
  TagScreenResponseInterface,
  TagScreenStateInterface,
  updateVerdictAction,
  DecisionStateInterface,
  getAllDecisionsAction,
} from '../../../../../../../common';
import { ExclamationCircleOutlined, DeleteOutlined, InboxOutlined } from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';
import { AdminRoutes } from '../../../../../_router/admin.routes';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import localeHR from 'antd/es/date-picker/locale/hr_HR';
import localeEN from 'antd/es/date-picker/locale/en_GB';

const { SHOW_ALL } = TreeSelect;

const { Dragger } = Upload;

const { confirm } = Modal;

interface Props {
  setTabOrder?: (verdictId: number) => void;
}

function VUSVerdictsCrudPageComponent({ setTabOrder }: Props) {

  const dispatch = useDispatch();
  const [form] = Form.useForm<any>();
  const data: VerdictStateInterface = useSelector((state: StoreStateInterface) => state.verdict);
  const decisions: DecisionStateInterface = useSelector((state: StoreStateInterface) => state.decision);
  const tags: TagScreenStateInterface = useSelector((state: StoreStateInterface) => state.tagScreen);
  const userAuth = useSelector((state: StoreStateInterface) => state.auth);

  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [pdfUuid, setPdfUuid] = useState('');
  const [vusFileList, setVusFileList] = useState<UploadFile[]>([]);
  const [vusUuid, setVusUuid] = useState('');

  useEffect(() => {
    dispatch(getScreenTagsByTypeAction('verdict'));
    dispatch(getAllDecisionsAction(undefined, undefined, 'sort=-id', `page[offset]=0&page[limit]=1000`));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    form.resetFields();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.currentVerdict]);

  const getId = () => {
    if (!data || !data.currentVerdict) return undefined;
    return data.currentVerdict.id;
  }

  useEffect(() => {
    if (getId()) {
      if (data?.currentVerdict?.attributes?.verdictPdfUuid) {
        FileService.list(data?.currentVerdict?.attributes?.verdictPdfUuid).subscribe(
          (response: any) => {
            setFileList([{ name: response.fileName, uid: response.uuid }]);
            setPdfUuid(response.uuid);
          },
          (error: Error) => {
            console.log(error);
          }
        );
      }
      if (data?.currentVerdict?.attributes?.vusVerdictPdfUuid) {
        FileService.list(data.currentVerdict?.attributes?.vusVerdictPdfUuid).subscribe(
          (response: any) => {
            setVusFileList([{ name: response.fileName, uid: response.uuid }]);
            setVusUuid(response.uuid);
          },
          (error: Error) => {
            console.log(error);
          }
        );
      }
      form.resetFields();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.currentVerdict?.attributes, tags]);

  const onFileDownload = () => {
    FileService.temp(pdfUuid).subscribe(
      (response: any) => {
        if (response.url) {
          notification['success']({ message: i18n.translate('api.downloadSuccessMessage'), duration: 2 });
          var link = document.createElement('a');
          link.href = response.url;
          link.download = 'file.pdf';
          link.dispatchEvent(new MouseEvent('click'));
        } else {
          notification['error']({ message: i18n.translate('api.errorMessage'), duration: 2 });
        }
      },
      (error: Error) => {
        notification['error']({ message: i18n.translate('api.errorMessage'), duration: 2 });
      }
    );
  };

  const onVusFileDownload = () => {
    FileService.temp(vusUuid).subscribe(
      (response: any) => {
        if (response.url) {
          notification['success']({ message: i18n.translate('api.downloadSuccessMessage'), duration: 2 });
          var link = document.createElement('a');
          link.href = response.url;
          link.download = 'file.pdf';
          link.dispatchEvent(new MouseEvent('click'));
        } else {
          notification['error']({ message: i18n.translate('api.errorMessage'), duration: 2 });
        }
      },
      (error: Error) => {
        notification['error']({ message: i18n.translate('api.errorMessage'), duration: 2 });
      }
    );
  };

  const beforeUpload = (file: any) => {
    if (!FileFormatEnum.ALLOWED.split(',').includes(file.type)) {
      message.error(i18n.translate('genericFileUpload.formatError', { filename: file.name }));
      return false;
    } else {
      return true;
    }
  };

  const onFileListChange = (info: any) => {
    if (!FileFormatEnum.ALLOWED.split(',').includes(info.file.type)) return;

    if (info.file.status === 'done') {
      passUuid(info.file.response[0].uuid);
      message.success(i18n.translate('genericFileUpload.uploadSuccess', { filename: info.file.name }));
    } else if (info.file.status === 'error') {
      message.error(i18n.translate('genericFileUpload.uploadFailed', { filename: info.file.name }));
    }
    setFileList([info.fileList.pop()]);
  };

  const onVusFileListChange = (info: any) => {
    if (!FileFormatEnum.ALLOWED.split(',').includes(info.file.type)) return;

    if (info.file.status === 'done') {
      passVusUuid(info.file.response[0].uuid);
      message.success(i18n.translate('genericFileUpload.uploadSuccess', { filename: info.file.name }));
    } else if (info.file.status === 'error') {
      message.error(i18n.translate('genericFileUpload.uploadFailed', { filename: info.file.name }));
    }
    setVusFileList([info.fileList.pop()]);
  };

  const onFileRemove = () => {
    passUuid('');
    setFileList([]);
  };

  const onVusFileRemove = () => {
    passVusUuid('');
    setVusFileList([]);
  };

  const props: UploadProps = {
    name: 'files',
    accept: FileFormatEnum.ALLOWED,
    beforeUpload: (file: any) => beforeUpload(file),
    multiple: false,
    action: process.env.REACT_APP_FILE_UPLOAD,
    onChange: (info: any) => onFileListChange(info),
    fileList: fileList,
    showUploadList: {
      showRemoveIcon: false,
    },
  };

  const propsVus: UploadProps = {
    name: 'files',
    accept: FileFormatEnum.ALLOWED,
    beforeUpload: (file: any) => beforeUpload(file),
    multiple: false,
    action: process.env.REACT_APP_FILE_UPLOAD,
    onChange: (info: any) => onVusFileListChange(info),
    fileList: vusFileList,
    showUploadList: {
      showRemoveIcon: false,
    },
  };

  const checkForNested = (tag: TagScreenResponseInterface) => {
    let nested = tag.children?.find((child) => child.nestedChildren?.length && child.nestedChildren?.length > 0);
    if (nested) return true;
    else return false;
  };

  const onFinishVerdict = (values: any) => {
    const getTags = () => {
      let array: Array<{ id: Number; type: string }> = [];
      tags.tagScreens?.forEach((tag) => {
        const value = values[tag.filter.name as keyof any];
        if (value) {
          if (tag?.selectType === SelectTypeEnum.SELECT || tag?.selectType === SelectTypeEnum.BOOLEAN || tag?.selectType === SelectTypeEnum.YEAR) {
            const childTag = tag.children?.find((child) => child.tag.id == value);
            if (childTag) array.push({ id: childTag.tag.id as number, type: 'tag' });
          }
          if (
            tag?.selectType === SelectTypeEnum.MULTISELECT ||
            tag?.selectType === SelectTypeEnum.ADVANCED
          ) {
            const value = values[tag.filter.name as keyof any];
            if (value && value.length && value.length > 0) {
              value.forEach((id: any) => {
                if (id) array.push({ id: id, type: 'tag' });
              });
            }
          }
        }
      });

      return array;
    };

    let verdictData: any = {
      data: {
        type: 'verdict',
        id: data.currentVerdict?.id,
        attributes: {
          verdictNum: values.verdictNum,
          plaintiff: values.plaintiff,
          vusVerdictLink: values.vusVerdictLink,
          verdictDate: values.verdictDate ? moment(values.verdictDate) : null,
          verdictPublishDate: values.verdictPublishDate ? moment(values.verdictPublishDate) : null,
          lawFirm: values.lawFirm,
          trialChamber: values.trialChamber,
          verdictPdfUuid: pdfUuid,
          vusVerdictPdfUuid: vusUuid,
        },
        relationships: {
          decision: {
            data: {
              id: values.decisionId,
              type: 'decision',
            },
          },
          tags: {
            data: getTags(),
          },
        },
      },
    };

    !getId() ? dispatch(createVerdictAction(verdictData)) : dispatch(updateVerdictAction(verdictData));
    window.scrollTo({ top: 0, behavior: 'smooth' });

    setTimeout(() => {
      setTab(store.getState().verdict.currentVerdict?.id as number);
    }, 2000);
  };

  const onFinishVerdictFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  const setTreeData = (children: Array<ChildrenTagScreenResponseInterface>) => {
    let values = children.map((child) => ({
      title: child.tag.name,
      value: child.tag.id,
      key: child.tag.id,
      children: child.nestedChildren?.map((nestedChild) => ({
        title: nestedChild.tag.name,
        value: nestedChild.tag.id,
        key: nestedChild.tag.id,
        children: nestedChild.nestedChildren?.map((nestedLvl2Child) => ({
          title: nestedLvl2Child.tag.name,
          value: nestedLvl2Child.tag.id,
          key: nestedLvl2Child.tag.id,
        })),
      })),
    }));
    return values;
  };

  const setCascaderData = (children: Array<ChildrenTagScreenResponseInterface>) => {
    let values = children.map((child) => ({
      label: child.tag.name,
      value: child.tag.id,
      key: child.tag.id,
      children: child.nestedChildren?.map((nestedChild) => ({
        label: nestedChild.tag.name,
        value: nestedChild.tag.id,
        key: nestedChild.tag.id,
        children: nestedChild.nestedChildren?.map((nestedLvl2Child) => ({
          label: nestedLvl2Child.tag.name,
          value: nestedLvl2Child.tag.id,
          key: nestedLvl2Child.tag.id,
        })),
      })),
    }));
    return values;
  };

  const getFilter = (field: string) => {
    let filter;
    let tag = tags.tagScreens?.find((tag) => tag.filter.name == field);
    if (tag) {
      let array: number[] = [];
      data.currentVerdict?.attributes?.tagIds?.forEach((id) => {
        tag?.children?.forEach((child) => {
          if (id === child.tag.id) {
            if (tag?.selectType === SelectTypeEnum.SELECT || tag?.selectType === SelectTypeEnum.BOOLEAN) {
              filter = child.tag.id;
            }
            if (
              tag?.selectType === SelectTypeEnum.YEAR ||
              tag?.selectType === SelectTypeEnum.MULTISELECT ||
              tag?.selectType === SelectTypeEnum.ADVANCED
            ) {
              array.push(child.tag.id);
            }
          }
          if (child.nestedChildren?.length) {
            child.nestedChildren?.forEach(nestedChild => {
              if (id === nestedChild.tag.id) {
                array.push(nestedChild.tag.id);
              }
              if (nestedChild.nestedChildren?.length) {
                nestedChild.nestedChildren?.forEach(nestedLvl2Child => {
                  if (id === nestedLvl2Child.tag.id) {
                    array.push(nestedLvl2Child.tag.id);
                  }
                });
              }
            });
          }
        });
      });

      if (
        tag?.selectType === SelectTypeEnum.YEAR ||
        tag?.selectType === SelectTypeEnum.MULTISELECT ||
        tag?.selectType === SelectTypeEnum.ADVANCED
      )
        filter = array;
    }
    return filter;
  };

  const loadInitialValues = () => {
    let values: any = {
      verdictNum: data.currentVerdict?.attributes?.verdictNum,
      plaintiff: data.currentVerdict?.attributes?.plaintiff,
      decisionId: data.currentVerdict?.relationships?.decision?.data?.id,
      vusVerdictLink: data.currentVerdict?.attributes?.vusVerdictLink,
      verdictDate: data.currentVerdict?.attributes?.verdictDate
        ? moment(data.currentVerdict?.attributes?.verdictDate)
        : null,
      verdictPublishDate: data.currentVerdict?.attributes?.verdictPublishDate
        ? moment(data.currentVerdict?.attributes?.verdictPublishDate)
        : null,
      lawFirm: data.currentVerdict?.attributes?.lawFirm,
      trialChamber: data.currentVerdict?.attributes?.trialChamber,
    };

    tags.tagScreens?.forEach((tag) => {
      values[tag.filter.name as keyof any] = getFilter(tag.filter.name);
    });

    return values;
  };

  const loadDefaultValues = () => {
    let values: any = {};

    tags.tagScreens?.forEach((tag) => {
      if (tag.filter.name == FilterNameEnumHR.ZJN) {
        values[tag.filter.name as keyof any] = [tag.children?.length ? tag.children[0].tag.id : []];
      }
    });

    return values;
  };

  const clearCurrentVerdict = () => {
    dispatch(clearVerdictAction());
  };

  const passUuid = (uuid: string) => {
    setPdfUuid(uuid);
  };

  const passVusUuid = (uuid: string) => {
    setVusUuid(uuid);
  };

  const showConfirm = () => {
    confirm({
      title: i18n.t('verdicts.confirmDelete'),
      icon: <ExclamationCircleOutlined />,
      content: i18n.t('common.cantUndo'),
      okText: i18n.t('genericButtons.yes'),
      cancelText: i18n.t('genericButtons.cancel'),
      onOk() {
        let id = getId();
        if (!id) {
          alert("Error");
          return;
        }
        dispatch(deleteVerdictAction(id));
        window.scrollTo({ top: 0, behavior: 'smooth' });

        setTimeout(() => {
          NavigationService.navigate(AdminRoutes.VUS_DECLARATIONS.fullPath);
        }, 1000);
      },
    });
  };

  const filterFromCurrentYear = (
    children: ChildrenTagScreenResponseInterface[]
  ): ChildrenTagScreenResponseInterface[] => {
    const currentYear = moment().format('YYYY');
    const currentYearChild = children.find((child) => child.tag.name == currentYear);
    const index = children.indexOf(currentYearChild as ChildrenTagScreenResponseInterface);
    if (index && index > 0) children.length = index + 1;
    return [...children].reverse();
  };

  const setTab = (verdictId: number) => {
    setTabOrder && setTabOrder(verdictId);
  };

  return (
    <div className="vusVerdictsCrud w100-h100">
      {(
        <Form
          form={form}
          layout="vertical"
          name="verdict"
          size="large"
          scrollToFirstError
          initialValues={getId() ? loadInitialValues() : loadDefaultValues()}
          onFinish={onFinishVerdict}
          onFinishFailed={onFinishVerdictFailed}
          autoComplete="off"
          requiredMark={false}
        >
          <div className="vusVerdictsCrud__form">
            <div className="subtitle">
              <span className="text">{i18n.translate('verdicts.form.sections.info')}</span>
            </div>

            <Form.Item
              label={<span className="text-bold">{i18n.translate(`verdicts.form.fields.verdictNum`)}</span>}
              name="verdictNum"
              rules={[{ required: true, message: i18n.translate(`genericFormMsg.required`) }]}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
            >
              <Input style={{ borderRadius: 0 }} />
            </Form.Item>

            <Form.Item
              label={<span className="text-bold">{i18n.translate(`verdicts.form.fields.decisionId`)}</span>}
              name="decisionId"
              rules={[{ required: true, message: i18n.translate(`genericFormMsg.required`) }]}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
            >
              <Select
                allowClear
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toString() ?? '').toLowerCase().includes(input.toLowerCase())
                }
              >
                {decisions.decisions?.data?.map((decision) => (
                  <Select.Option key={'article' + decision?.id} value={decision.id} label={decision?.attributes?.clazz}>
                    {decision?.attributes?.clazz}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label={<span className="text-bold">{i18n.translate(`verdicts.form.fields.verdictDate`)}</span>}
              //rules={[{ required: true, message: i18n.translate(`genericFormMsg.required`) }]}
              name="verdictDate"
            >
              {/** DISABLED DATE ISPOD AKO TREBA */}
              <DatePicker
                style={{ borderRadius: 0 }}
                locale={userAuth.lang == 'hr' ? localeHR : localeEN}
                format={DisplayDateFormat}
              />
            </Form.Item>

            <Form.Item
              label={<span className="text-bold">{i18n.translate(`verdicts.form.fields.verdictPublishDate`)}</span>}
              rules={[{ required: true, message: i18n.translate(`genericFormMsg.required`) }]}
              name="verdictPublishDate"
            >
              {/** DISABLED DATE ISPOD AKO TREBA */}
              <DatePicker
                style={{ borderRadius: 0 }}
                locale={userAuth.lang == 'hr' ? localeHR : localeEN}
                format={DisplayDateFormat}
              />
            </Form.Item>

            <Form.Item
              label={<span className="text-bold">{i18n.translate(`verdicts.form.fields.plaintiff`)}</span>}
              name="plaintiff"
              rules={[{ required: true, message: i18n.translate(`genericFormMsg.required`) }]}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
            >
              <Input style={{ borderRadius: 0 }} />
            </Form.Item>

            <div className="subtitle">
              <span className="text">{i18n.translate('verdicts.form.sections.filters')}</span>
            </div>

            {/** OVDJE ISPOD SVI FILTERI TREBAJU BITI GENERIČKI */}

            {tags.tagScreens?.map((tag) => (
              <Form.Item
                label={<span className="text-bold">{`${tag.filter.name}`}</span>}
                name={tag.filter.name}
                key={tag.filter.name}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 8 }}
              >
                {tag.selectType === SelectTypeEnum.BOOLEAN ? (
                  <Radio.Group>
                    <Radio.Button value={tag.children?.length ? tag.children[0].tag.id : 0}>
                      {tag.children?.length ? tag.children[0].tag.name : ''}
                    </Radio.Button>
                    <Radio.Button value={tag.children?.length ? tag.children[1].tag.id : 1}>
                      {tag.children?.length ? tag.children[1].tag.name : ''}
                    </Radio.Button>
                  </Radio.Group>
                ) : checkForNested(tag) &&
                  (tag.selectType === SelectTypeEnum.MULTISELECT || tag.selectType === SelectTypeEnum.ADVANCED) ? (
                  tag.selectType === SelectTypeEnum.ADVANCED ? (
                    <TreeSelect
                      treeData={setTreeData(tag.children as Array<ChildrenTagScreenResponseInterface>)}
                      treeCheckable
                      showCheckedStrategy={SHOW_ALL}
                      maxTagCount="responsive"
                    />
                  ) : (
                    <TreeSelect
                      treeData={setTreeData(tag.children as Array<ChildrenTagScreenResponseInterface>)}
                      treeCheckable
                      showCheckedStrategy={SHOW_ALL}
                      maxTagCount="responsive"
                    />
                  )
                ) : (
                  <Select
                    mode={
                      tag.selectType === SelectTypeEnum.MULTISELECT || tag.selectType === SelectTypeEnum.ADVANCED
                        ? 'multiple'
                        : undefined
                    }
                    maxTagCount={
                      tag.selectType === SelectTypeEnum.MULTISELECT || tag.selectType === SelectTypeEnum.ADVANCED
                        ? 'responsive'
                        : undefined
                    }
                    allowClear
                  >
                    {tag.selectType === SelectTypeEnum.YEAR
                      ? tag.children?.length &&
                        filterFromCurrentYear(tag.children) &&
                        filterFromCurrentYear(tag.children)?.length &&
                        filterFromCurrentYear(tag.children).map((child) => (
                          <Select.Option key={child.tag.name} value={child.tag.id}>
                            {child.tag.name}
                          </Select.Option>
                        ))
                      : tag.children?.length &&
                        tag.children.map((child) => (
                          <Select.Option key={child.tag.name} value={child.tag.id}>
                            {child.tag.name}
                          </Select.Option>
                        ))}
                  </Select>
                )}
              </Form.Item>
            ))}

            {/** GENERIC FILTERI END */}

            <div className="subtitle">
              <span className="text">{i18n.translate('verdicts.form.sections.upload')}</span>
            </div>

            <Form.Item
              label={<span className="text-bold">{i18n.translate(`verdicts.form.fields.vusVerdictLink`)}</span>}
              name="vusVerdictLink"
              rules={[{ required: true, message: i18n.translate(`genericFormMsg.required`) }]}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
            >
              <Input style={{ borderRadius: 0 }} />
            </Form.Item>

            <Form.Item
              label={<span className="text-bold">{i18n.translate(`verdicts.form.fields.pdf`)}</span>}
              name="pdf"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 10 }}
              //rules={
                //fileList.length === 0 ? [{ required: true, message: i18n.translate(`genericFormMsg.required`) }] : []
              //}
            >
              <Dragger {...props}>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">{i18n.translate(`verdicts.form.upload.text`)}</p>
              </Dragger>
            </Form.Item>

            {fileList && fileList.length > 0 && (
              <div>
                <Button type="link" style={{ color: 'red', marginBottom: 8 }} onClick={onFileRemove}>
                  {i18n.translate(`genericButtons.delete`)}
                </Button>
                <Button type="link" style={{ marginLeft: 8, marginBottom: 8 }} onClick={onFileDownload}>
                  {i18n.translate(`genericButtons.download`)}
                </Button>
              </div>
            )}

            <Form.Item
              label={<span className="text-bold">{i18n.translate(`verdicts.form.fields.pdfVus`)}</span>}
              name="pdfVus"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 10 }}
              rules={
                vusFileList.length === 0 ? [{ required: true, message: i18n.translate(`genericFormMsg.required`) }] : []
              }
            >
              <Dragger {...propsVus}>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">{i18n.translate(`verdicts.form.upload.text`)}</p>
              </Dragger>
            </Form.Item>

            {vusFileList && vusFileList.length > 0 && (
              <div>
                <Button type="link" style={{ color: 'red', marginBottom: 8 }} onClick={onVusFileRemove}>
                  {i18n.translate(`genericButtons.delete`)}
                </Button>
                <Button type="link" style={{ marginLeft: 8, marginBottom: 8 }} onClick={onVusFileDownload}>
                  {i18n.translate(`genericButtons.download`)}
                </Button>
              </div>
            )}

            <div style={{ marginTop: 16 }} className="subtitle">
              <span className="text">{i18n.translate('verdicts.form.sections.admin')}</span>
            </div>

            <Form.Item
              label={<span className="text-bold">{i18n.translate(`verdicts.form.fields.lawFirm`)}</span>}
              name="lawFirm"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
            >
              <Input style={{ borderRadius: 0 }} />
            </Form.Item>

            <Form.Item
              label={<span className="text-bold">{i18n.translate(`verdicts.form.fields.trialChamber`)}</span>}
              name="trialChamber"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
            >
              <Input style={{ borderRadius: 0 }} />
            </Form.Item>
          </div>
          <div className="vusVerdictsCrud__bottomButtons">
            <div>
              {getId() && (
                <Button
                  danger
                  onClick={showConfirm}
                  className="button"
                  size="large"
                  icon={<DeleteOutlined />}
                  style={{ fontSize: 16, fontWeight: 700, borderRadius: 0, minWidth: 193 }}
                >
                  {i18n.translate('genericButtons.delete')}
                </Button>
              )}
            </div>
            <div>
              <Link to={AdminRoutes.VUS_DECLARATIONS.fullPath} key={AdminRoutes.VUS_DECLARATIONS.path}>
                <Button
                  onClick={clearCurrentVerdict}
                  className="button"
                  size="large"
                  style={{ fontSize: 16, fontWeight: 700, borderRadius: 0, minWidth: 193, marginRight: 16 }}
                >
                  {i18n.translate('genericButtons.cancel')}
                </Button>
              </Link>
              <Button
                className="button"
                htmlType="submit"
                type="primary"
                size="large"
                style={{ fontSize: 16, fontWeight: 700, borderRadius: 0, minWidth: 193 }}
              >
                {i18n.translate('genericButtons.save')}
              </Button>
            </div>
          </div>
        </Form>
      )}
    </div>
  );
}

export default VUSVerdictsCrudPageComponent;
